const Coins = ({ color, type }) => {
  const regular = (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00024 19.9999C11.9762 19.9999 16.0002 18.6259 16.0002 15.9999V3.99994C16.0002 1.37394 11.9762 -6.10352e-05 8.00024 -6.10352e-05C4.02424 -6.10352e-05 0.000244141 1.37394 0.000244141 3.99994V15.9999C0.000244141 18.6259 4.02424 19.9999 8.00024 19.9999ZM8.00024 17.9999C4.27824 17.9999 2.00024 16.7049 2.00024 15.9999V14.7319C3.54124 15.5699 5.77724 15.9999 8.00024 15.9999C10.2232 15.9999 12.4592 15.5699 14.0002 14.7319V15.9999C14.0002 16.7049 11.7222 17.9999 8.00024 17.9999ZM8.00024 1.99994C11.7222 1.99994 14.0002 3.29494 14.0002 3.99994C14.0002 4.70494 11.7222 5.99994 8.00024 5.99994C4.27824 5.99994 2.00024 4.70494 2.00024 3.99994C2.00024 3.29494 4.27824 1.99994 8.00024 1.99994ZM2.00024 6.73194C3.54124 7.56994 5.77724 7.99994 8.00024 7.99994C10.2232 7.99994 12.4592 7.56994 14.0002 6.73194V7.99994C14.0002 8.70494 11.7222 9.99994 8.00024 9.99994C4.27824 9.99994 2.00024 8.70494 2.00024 7.99994V6.73194ZM2.00024 10.7319C3.54124 11.5699 5.77724 11.9999 8.00024 11.9999C10.2232 11.9999 12.4592 11.5699 14.0002 10.7319V11.9999C14.0002 12.7049 11.7222 13.9999 8.00024 13.9999C4.27824 13.9999 2.00024 12.7049 2.00024 11.9999V10.7319Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Coins;
